import React from "react";
import { Alert } from "antd";
import OrderTab from "../../enum/OrderTab";
import { Link } from "react-router-dom";

interface AbnormalAlertProps {
    shopId: number;

    tab: OrderTab;
}

const AbnormalAlert: React.FC<AbnormalAlertProps> = ({ shopId, tab }) => {
    if (tab === OrderTab.ABNORMAL) {
        return null;
    }

    return (
        <Alert
            type="error"
            title={
                <p style={{ color: "#a94442" }}>
                    <strong>有异常订单,</strong>
                    <span>请先查看异常原因并处理以免误发货,</span>
                    <Link to={{ pathname: "/order/list", search: `shopId=${shopId}&tab=${OrderTab.ABNORMAL}` }}>
                        点击这里查看异常订单
                    </Link>
                </p>
            }
            className="p15 mb10"
        />
    );
};

export default React.memo(AbnormalAlert);
